import React from 'react';
import PropTypes from 'prop-types';
import { DebounceInput } from 'react-debounce-input';
import { NUMERIC_VALUE } from '../../../../utils';

function SearchContainer(props) {
  const { search } = props;
  return (
    <>
      <div className="search">
        <DebounceInput
          minLength={NUMERIC_VALUE.TWO}
          type="search"
          placeholder="Search Artist"
          debounceTimeout={NUMERIC_VALUE.THREE_HUNDRED}
          onChange={(event) => search(event.target.value)}
        />
        <span className="search-icon" />
      </div>
    </>
  );
}

SearchContainer.propTypes = {
  search: PropTypes.func.isRequired,
};

export default SearchContainer;
